import {Component, OnInit} from '@angular/core';
import {CartModel} from "./cartModel";

export class ItemProperty {
    data = {
        id: null,
    };

    constructor(public data1: any, coupons=[], currency_data = []) {
        this.data = data1;
    }

    //shortHeaders = [];
    prefix = 'itemProperty';
    title = "itemProperty";
    dataFields = {
        id: {'title': 'ID', 'value': null, 'type': 'number', 'readonly': true},
        created: {'title': 'Created', 'value': null, 'type': 'date', 'readonly': true},
        updated: {'title': 'Updated', 'value': null, 'type': 'date', 'readonly': true},
    }
}
